import * as angular from 'angular';
import { Constants as constants } from '@constants/shared';
import {compliance} from '@app/compliance/compliance.component';
import {ComplianceRepo as complianceRepo} from '@services/compliance.repo'

export const complianceModule = 'compliance';

angular
  .module(complianceModule, ['xeditable', 'ngMaterial', 'isoCurrency', 'dataGrid', 'pagination'])
  .constant("config", constants.Default)
  .component("compliance", compliance)
  .service("complianceRepo", complianceRepo)





// WEBPACK FOOTER //
// ./src/app/compliance/compliance.index.ts